<main class="table-condensed-component-scss">
	<section class="flex flex-col relative w-full">
		@for (lane of table.body; track lane; let index = $index) {
			<div
				(click)="clickTableLine(lane)"
				#itemList
				[ngClass]="{
					'hover:text-primary text-gray-600 cursor-pointer': lineCickable,
					'mt-[18px]': index > 0
				}"
				[class.ttfc-data-motion-prev]="paginationType === 'prev'"
				[class.motion-go-right]="paginationType === 'prev'"
				[class.ttfc-data-motion]="paginationType === 'next'"
				[class.motion-go-left]="paginationType === 'next'"
				[class.fade-out-top]="lane.edit"
				[style.animation-delay.ms]="index * 60"
				class="flex flex-col justify-center transition duration-600 ease-in-out relative mb-[10px]"
			>
				@for (col of table.columns; track col) {
					@if (col.type === 'action-delete') {
						<section
							class="table-confirm-remove transition duration-600 ease-in-out"
							[class.opacity-100]="lane.remove"
							[class.opacity-0]="!lane.remove"
							[class.shake-horizontal]="lane.confirmDelete"
							[class.contentDelete]="lane.delete"
							[class.notContentDelete]="!lane.delete"
						>
							<lbca-icon
								name="lucide:trash"
								class="table-trash"
								(click)="col.functionDelete(lane)"
							></lbca-icon>
						</section>
					}
				}
				<section
					class="flex justify-between items-center rounded-lg flex-row hover:shadow transition duration-600 ease-in-out pl-[6px] pr-[10px] bg-gray-50 hover:bg-gray-50"
					[class.shake-horizontal]="lane.confirmDelete"
					[class.shadow]="lane.opened || highlight === true"
					[ngClass]="{
						'ml-[40px] w-[97%]': checkLineDeslocation(lane),
						'w-full': !checkLineDeslocation(lane)
					}"
				>
					<div class="flex items-center relative w-full flex-wrap">
						@for (col of table.columns; track col) {
							@if (
								col.type !== 'three-action' &&
								col.type !== 'action-delete' &&
								col.type !== 'action-flag-to-delete' &&
								lane[col.name]
							) {
								<div
									class="ff-box-field mt-[20px] mb-[20px] w-full p-[0px]"
									[ngClass]="'ff-field-size-' + col['field'].size"
								>
									<div class="flex items-start relative w-full">
										@if (!col['templateRef'] && !col['field']) {
											<div [lbcaTable]="col" [laneData]="lane" class="text-xs text w-full"></div>
										}
										@if (!col['templateRef'] && col['field']) {
											<div class="text-xs w-full">
												<ng-container
													[ngTemplateOutlet]="condensedFields"
													[ngTemplateOutletContext]="{ $implicit: lane, col: col }"
												></ng-container>
											</div>
										}
										@if (col['templateRef']) {
											<div class="text-xs w-full">
												<ng-container
													[ngTemplateOutlet]="col.templateRef"
													[ngTemplateOutletContext]="{ $implicit: lane }"
												></ng-container>
											</div>
										}
									</div>
								</div>
							}
						}
					</div>
					<div class="w-100 flex justify-end pr-[15px]">
						@if (table.details && table.details.length > 0) {
							<div>
								<div>
									<lbca-icon
										class="bg-gray-600 transition duration-400 ease-in-out cursor-pointer"
										name="lucide:chevron-down"
										[class.rotate-180]="lane.opened"
										(click)="lane.opened = !lane.opened"
									></lbca-icon>
								</div>
								@if (false && !isDisabled) {
									<div
										class="svg-icon-error bg-gray-600 transition duration-400 ease-in-out cursor-pointer"
										(click)="lane.opened = !lane.opened"
									></div>
								}
							</div>
						}
						<div class="flex flex-row flex-wrap items-center w-full">
							@for (col of table.columns; track col) {
								@if (col.type === 'action-flag-to-delete') {
									<div>
										@if (col['templateRef']) {
											<ng-container
												[ngTemplateOutlet]="col.templateRef"
												[ngTemplateOutletContext]="{ $implicit: lane }"
											></ng-container>
										}
									</div>
								}
								@if (col.type === 'three-action') {
									<div
										(click)="stopPropagation($event)"
										class="flex items-center justify-end relative"
										[ngStyle]="{ width: getPercents(col.col) }"
									>
										<label
											for="tertiary-actions-{{ index }}"
											class="flex items-center cursor-pointer h-[24px] w-6 justify-center relative"
										>
											<span class="tertiary-actions"></span>
											<input
												lbcaTableClickOutside
												id="tertiary-actions-{{ index }}"
												type="checkbox"
												class="hidden dropdown-select"
											/>
											<div
												class="top--4 max-h-[224px] bg-gray-200 text-xs right-0 shadow-md rounded absolute dropdown-content hidden show pt-[16px] pb-[16px]"
											>
												<div class="h-full overflow-y-auto">
													@for (act of col.actions; track act) {
														<div
															(click)="act.function(lane)"
															class="h-[32px] flex items-center pl-[32px] cursor-pointer text-sm tracking-[1px]"
														>
															{{ act.label }}
														</div>
													}
												</div>
											</div>
										</label>
									</div>
								}
							}
						</div>
					</div>
				</section>
				@if (lane.opened) {
					<section
						class="flex items-center rounded-lg flex-row flex-wrap transition duration-600 ease-in-out h-auto pt-[25px] -mt-[15px] pb-[2px] pl-[20px] pr-[16px] bg-gray-50 hover:bg-gray-50 z-[900]"
						[class.shadow-inner]="highlight === true"
						[class.shake-horizontal]="lane.confirmDelete"
						[ngClass]="{
							'ml-[40px] w-[97%]': checkLineDeslocation(lane),
							'w-full': !checkLineDeslocation(lane)
						}"
					>
						<div class="flex items-center relative pt-[20px] pb-[10px] flex-wrap w-full">
							@for (col of table.details; track col) {
								@if (lane[col.name]) {
									<div class="ff-box-field" [ngClass]="'ff-field-size-' + col['field'].size">
										<div class="flex flex-row flex-wrap items-center relative w-full">
											<div class="pr-[8px] text-xs w-full">
												<ng-container
													[ngTemplateOutlet]="condensedFields"
													[ngTemplateOutletContext]="{
														$implicit: lane,
														col: col
													}"
												></ng-container>
											</div>
										</div>
									</div>
								}
							}
						</div>
					</section>
				}
			</div>
		}
	</section>
</main>

<ng-template #condensedFields let-lane let-col="col">
	@if (col['field'].type === 'HIDDEN') {
		<lbca-input-hidden [label]="col['field'].label"
			[defaultValue]="col['field'].defaultValue"
		 />
	}
	@if (col['field'].type === 'TEXT') {
		<lbca-input-text-condensed [label]="col['field'].label"
			[tabeled]="false"
			[labeled]="false"
			[error]="[]"
			[require]="col['field'].required"
			[maskInput]="col['field'].mask"
			[value]="lane[col.name]"
		 />
	}
	@if (col['field'].type === 'DATE_TIME') {
		<lbca-date-time-picker-condensed [value]="lane[col.name]"
			[labeled]="false"
			[tabeled]="false"
			[labelDate]="col['field'].labelDate"
			[labelTime]="col['field'].labelTime"
			[require]="col['field'].required"
			[error]="[]"
		 />
	}
	@if (col['field'].type === 'CALENDAR') {
		<lbca-date-picker-condensed [labeled]="false"
			[tabeled]="false"
			[label]="col['field'].label"
			[require]="col['field'].required"
			[error]="[]"
			[value]="lane[col.name]"
		 />
	}
	@if (col['field'].type === 'TIME') {
		<lbca-timepicker-condensed [labeled]="false"
			[tabeled]="false"
			[label]="col['field'].label"
			[require]="col['field'].required"
			[error]="[]"
			[value]="lane[col.name]"
		 />
	}
	@if (col['field'].auxEntity) {
		<lbca-entity-fields [forceType]="'SELECT_ONE_CONDENSED'"
			[tabeled]="false"
			[labeled]="false"
			[field]="col['field']"
			[label]="col['field'].label"
			[error]="[]"
			[require]="col['field'].required"
			[cardData]="cardInfo"
			[value]="lane[col.name]"
		 />
	}
	@if (col['field'].type === 'TEXTAREA') {
		<lbca-textarea-condensed [label]="col['field'].label"
			[value]="lane[col.name]"
			[laneData]="lane"
		 />
	}

	@if (col['field'].type === 'GRIDBOX') {
		<lbca-gridbox [field]="col['field']"
			[dataAttr]="dataAttr"
			[cardData]="cardInfo"
			[template]="col['field'].template"
			[configuration]="col['field'].configuration"
			[label]="col['field'].label"
			[labeled]="true"
			[error]="[]"
			[require]="col['field'].required"
			(changeValue)="changeValue($event, col['field'], lane, col.name)"
			[dynamicFormService]="dynamicFormService"
			[gridFormModuleInstance]="gridFormModuleInstance"
			[value]="lane[col.name]"
			[disabled]="col['field'].disabled"
		 />
	}

	@if (col['field'].type === 'TABLE_LIST') {
		<lbca-table-list [cardData]="cardInfo"
			[disabled]="true"
			[field]="col['field']"
			[dataAttr]="dataAttr"
			[value]="lane[col.name]"
		 />
	}

	@if (col['field'].type === 'SELECT_TREE') {
		<lbca-select-tree-condensed [label]="col['field'].label"
			[cardData]="cardInfo"
			[field]="col['field']"
			[value]="lane[col.name]"
		 />
	}

	@if (col['field'].type === 'FILE_UPLOAD') {
		<lbca-sub-module-file-upload [idEntity]="col['field'].entityKey"
			[label]="col['field'].label"
			[dataAttr]="dataAttr"
			[condensedView]="true"
			[cardData]="cardInfo"
			[error]="[]"
			[disabled]="isDisabled || col['field'].disabled"
			[value]="lane[col.name]"
			[properties]="col['field']"
		 />
	}

	@if (col['field'].type === 'ADDITIONAL_VALUES') {
		<lbca-additional-values-condensed [field]="col['field'].fields"
			[disabled]="isDisabled || col['field'].disabled"
			[cardData]="cardInfo"
			[value]="lane[col.name]"
		 />

		@if (col['field'].type === 'FILE_FROM_PROCESS') {
			<lbca-file-from-process
				[label]="col['field'].label"
				[buttonLabel]="col['field'].buttonLabel"
				[value]="data ? data[col['field'].entityKey] : ''"
				[context]="col['field'].context"
				[cardData]="cardInfo"
				[properties]="col['field']"
			>
				>
			</lbca-file-from-process>
		}
	}
</ng-template>
